import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {UntypedFormControl, Validators} from '@angular/forms';
import {Mode} from '../../../models/mode';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-prd-description',
    templateUrl: './prd-description.component.html',
    standalone: false
})
export class PrdDescriptionComponent implements OnInit {
    @ViewChild('initialDescription') initialDescription: ElementRef<HTMLParagraphElement> | undefined = undefined;

    @Input() title = 'Projectomschrijving';
    @Input() text = '';
    @Input() mode$: Observable<Mode>|undefined;
    @Output() save = new EventEmitter<string>();

    overflowHidden = false;
    expanded = false;
    editText = false;
    projectDescriptionFormControl = new UntypedFormControl(null, [Validators.maxLength(10000)]);

    ModeRead = Mode.Read;
    ModeEdit = Mode.Edit;

    overflowContentReadClassList = 'px-1 -mx-1 py-1 -my-2 md:px-3 md:-mx-3 md:py-2 md:-my-2 mb-4 leading-6 rounded break-word';
    overflowContentEditClassList = `${this.overflowContentReadClassList} hover:bg-neutral-4 cursor-pointer`;

    ngOnInit(): void {
        this.projectDescriptionFormControl.setValue(this.text);
    }

    openTextEditor(mode: Mode): void {
        if (mode === this.ModeRead) {
            return;
        }

        this.editText = true;

        // Minimize / reset text so prevent issues with show more not showing up
        this.expanded = false;
    }

    closeTextEditor(): void {
        this.editText = false;
        this.projectDescriptionFormControl.setValue(this.text);
    }

    saveText(): void {
        this.text = this.projectDescriptionFormControl.value;
        this.editText = false;

        this.save.emit(this.text);
    }

    onOverflowHiddenChange(overflowHidden: boolean): void {
        this.overflowHidden = overflowHidden;
    }
}
